import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import * as async from 'async';
import moment from 'moment';
import { OverlayPanel } from 'primeng/overlaypanel';
import { ServicesService } from 'src/app/shared/services/services.service';
import { ClassificationsService } from 'src/app/shared/services/classifications.service';
import { HttpErrorResponse } from '@angular/common/http';
import { BinderClassificationDtoV2 } from 'src/app/shared/interfaces';
import { DocumentsService } from 'src/app/shared/services/documents.service';
import { DocumentStatusDto } from 'src/app/shared/interfaces/documents/document-status-dto.interface';
import { Contact } from 'src/app/shared/models/iContact/contact/contact';
import { ComplementData } from 'src/app/shared/models/complementData';
import { MultipleStatutesService } from 'src/app/shared/services/multiple-statutes.service';
import { MultipleStatutesDTO } from 'src/app/shared/models/iCourrier/status-management/multiple-statutes';

@Component({
  selector: 'app-display-filters',
  templateUrl: './display-filters.component.html',
  styleUrls: ['./display-filters.component.scss'],
})
export class DisplayFiltersComponent {
  @ViewChild('overlayButtonDisplayFilters') overlayButtonDisplayFilters: OverlayPanel;

  @Input() set filters(value) {
    if (value.length > 0) {
      this.filtersReceived = value;
      this.settingQueries();
    }
  }

  @Input() contacts: Contact[];
  @Input() contactsiAdmin: Contact[];
  @Input() naturesLV: { label: string; value: number; natureCustomFields: ComplementData[] }[];
  @Input() sourcesLV: { label: string; value: number }[];
  @Output() resetAdvancedSearch: EventEmitter<string> = new EventEmitter();

  public filtersReceived = [];

  public translatedFilters = [];

  private boxesTranslation = [
    { value: 'All', label: 'Tous les courriers' },
    { value: 'Entrant', label: 'Tous les entrants' },
    { value: 'Sortant', label: 'Tous les sortants' },
    { value: 'Interne', label: 'Tous les internes' },
    { value: 'NonLus', label: 'Non lu(s)' },
    { value: 'Lus', label: 'Lu(s)' },
    { value: 'PourInfo', label: 'Pour information' },
    { value: 'APrendreEnCharge', label: 'Prise en charge pour mon service' },
    { value: 'PrisEnCharge', label: 'Prise en charge demandée par mon service' },
    { value: 'NonPrisEnCharge', label: 'Demandes non prises en charge par mon service' },
    { value: 'AValider', label: 'Courriers entrants à valider' },
    { value: 'ADistribuer', label: 'A distribuer' },
    { value: 'ACompleter', label: 'A compléter' },
    { value: 'MalRoutes', label: 'Mal routé(s)' },
    { value: 'Epingles', label: 'Epinglé(s)' },
    { value: 'PourAction', label: 'Pour action' },
    { value: 'RecemmentConsultes', label: 'Récemment consulté(s)' },
    { value: 'RecemmentCrees', label: 'Récemment créé(s)' },
    { value: 'AClasser', label: 'Courrier à classer' },
    { value: 'bacsIds', label: 'Bacs' },
  ];
  private services = [];
  private classements = [];
  private statutGlobalLV: { label: string; value: number; color: string }[] = [];
  private tagsLV: { label: string; value: number }[] = [];

  public typeEntrantSortantLV = [
    { label: 'Sortant', value: 'S' },
    { label: 'Sortant', value: 'Sortant' },
    { label: 'Entrant', value: 'E' },
    { label: 'Entrant', value: 'Entrant' },
    { label: 'Interne', value: 'I' },
    { label: 'Interne', value: 'Interne' },
  ];

  constructor(
    private servicesService: ServicesService,
    private classificationsService: ClassificationsService,
    private documentsService: DocumentsService,
    private multipleStatutesService: MultipleStatutesService
  ) {}

  settingQueries() {
    this.translatedFilters = [];
    async.parallel(
      [
        //on va faire les requêtes en || afin de perdre le moins de temps possible
        (callback) => {
          this.getServices().then(() => {
            callback();
          });
        },
        (callback) => {
          this.getClassements().then(() => {
            callback();
          });
        },
        (callback) => {
          this.getStatus().then(() => {
            callback();
          });
        },
        (callback) => {
          this.getTags().then(() => {
            callback();
          });
        },
      ],
      () => {
        this.translateFilters();
      }
    );
  }

  translateFilters(): void {
    this.filtersReceived.find((key) => key.label === 'Objet')?.value
      ? decodeURIComponent(this.filtersReceived.find((key) => key.label === 'Objet').value)
      : '';

    this.filtersReceived.map((x) => {
      //on va pusher dans l'array en fonction de chaque catégorie
      //Certaines sont dans un if seules car elles ne peuvent être mélangées à d'autres à cause de leur manière de récupérer l'information
      if (
        x.label === 'Confidentiel' ||
        x.label === 'BoolObjetText' ||
        x.label === 'CourrierSansDestinataires' ||
        x.label === 'CourrierSansServices' ||
        x.label === 'recurrence'
      ) {
        // Booléens
        this.translatedFilters.push({ labelToTranslate: x.label, isLabel: ' est ', endLabelItalic: '✔️' });
      } else if (x.label === 'category' && x.value) {
        // Catégories
        const category = this.boxesTranslation.find((box) => box.value.toUpperCase() === x.value.toUpperCase())?.label;
        this.translatedFilters.push({
          labelToTranslate: 'Catégorie',
          isLabel: ' is ',
          endLabelItalic: category,
        });
      } else if (x.label === 'Type') {
        //Type de courrier
        const typeLabel = this.typeEntrantSortantLV.find((box) => box.value === x.value)?.label;
        this.translatedFilters.push({
          labelToTranslate: 'Type de courrier',
          isLabel: ' is ',
          endLabelItalic: typeLabel,
        });
      } else if (x.label === 'SvcPropIds' && x.value.length > 0) {
        // Service(s) (this.services)
        const servicesArray = [];
        let servicesLabels = '';
        x.value.map((x) => {
          servicesArray.push(this.services.find((service) => service.id === x)?.description);
        });
        servicesLabels = servicesArray.join(', ');
        if (servicesArray.length === 1) {
          this.translatedFilters.push({
            labelToTranslate: 'Service',
            isLabel: ' is ',
            endLabelItalic: servicesLabels,
          });
        } else {
          this.translatedFilters.push({
            labelToTranslate: 'Services',
            isLabel: ' are ',
            endLabelItalic: servicesLabels,
          });
        }
      } else if (x.label === 'DestinataireServiceIds') {
        // Services destinataires (this.services)
        const destinataireServiceArray = [];
        let destinataireServiceLabels = '';
        x.value.map((x) => {
          destinataireServiceArray.push(this.services.find((service) => service.id === x)?.description);
        });
        destinataireServiceLabels = destinataireServiceArray.join(', ');
        if (destinataireServiceArray.length === 1) {
          this.translatedFilters.push({
            labelToTranslate: 'Service destinataire',
            isLabel: ' is ',
            endLabelItalic: destinataireServiceLabels,
          });
        } else {
          this.translatedFilters.push({
            labelToTranslate: 'Services destinataires',
            isLabel: ' are ',
            endLabelItalic: destinataireServiceLabels,
          });
        }
      } else if ((x.label === 'ExpediteurIds' || x.label === 'ExpediteurIdiAdmins') && x.value.length > 0) {
        //Expéditeurs ids (this.contacts)
        //ExpediteurIdiAdmins (this.contactsiAdmin)
        const expediteursArray = [];
        let expediteursLabels = '';

        if (x.label === 'ExpediteurIds') {
          x.value.map((x) => {
            expediteursArray.push(this.contacts.find((expediteur) => expediteur.id === x)?.name);
          });
        } else if (x.label === 'ExpediteurIdiAdmins') {
          x.value.map((x) => {
            expediteursArray.push(this.contactsiAdmin.find((expediteur) => expediteur.id === x)?.name);
          });
        }

        expediteursLabels = expediteursArray.join(', ');
        if (expediteursArray.length === 1) {
          this.translatedFilters.push({
            labelToTranslate: 'Expéditeur',
            isLabel: ' is ',
            endLabelItalic: expediteursLabels,
          });
        } else {
          this.translatedFilters.push({
            labelToTranslate: 'Expéditeurs',
            isLabel: ' are ',
            endLabelItalic: expediteursLabels,
          });
        }
      } else if ((x.label === 'DestinataireIds' || x.label === 'DestinataireIdiAdmins') && x.value.length > 0) {
        //Destinataires Ids (this.contacts)
        // DestinataireIdiAdmins (this.contactsiAdmin)
        const destinatairesArray = [];
        let destinatairesLabels = '';
        if (x.label === 'DestinataireIds') {
          x.value.map((x) => {
            destinatairesArray.push(this.contacts.find((destinataire) => destinataire.id === x)?.name);
          });
        } else if (x.label === 'DestinataireIdiAdmins') {
          x.value.map((x) => {
            destinatairesArray.push(this.contactsiAdmin.find((destinataire) => destinataire.id === x)?.name);
          });
        }
        destinatairesLabels = destinatairesArray.join(', ');
        if (destinatairesArray.length === 1) {
          this.translatedFilters.push({
            labelToTranslate: 'Destinataire',
            isLabel: ' is ',
            endLabelItalic: destinatairesLabels,
          });
        } else {
          this.translatedFilters.push({
            labelToTranslate: 'Destinataires',
            isLabel: ' are ',
            endLabelItalic: destinatairesLabels,
          });
        }
      } else if (x.label === 'ClassementIds' && x.value.length > 0) {
        //Classements
        if (this.classements.length > 0) {
          const classementsArray = [];
          let classementsLabels = '';
          x.value.map((x) => {
            classementsArray.push(this.classements.find((classement) => classement.id === x)?.description);
          });
          classementsLabels = classementsArray.join(', ');
          if (classementsArray.length === 1) {
            this.translatedFilters.push({
              labelToTranslate: 'Code de classement',
              isLabel: ' is ',
              endLabelItalic: classementsLabels,
            });
          } else {
            this.translatedFilters.push({
              labelToTranslate: 'Codes de classement',
              isLabel: ' are ',
              endLabelItalic: classementsLabels,
            });
          }
        }
      } else if (x.label === 'ClasseurId') {
        const classificationCode = this.filtersReceived.find((filter) => filter.label === 'ClassementIds')?.value[0];
        const rightClassification = this.classements.find((item) => item.id === classificationCode);
        const rightBinder = rightClassification.classeurs.find((binder) => binder.id === x.value);
        this.translatedFilters.push({
          labelToTranslate: 'Farde',
          isLabel: ' is ',
          endLabelItalic: rightBinder.description,
        });
      } else if (x.label === 'ChemiseId') {
        const classificationCode = this.filtersReceived.find((filter) => filter.label === 'ClassementIds')?.value[0];
        const binderCode = this.filtersReceived.find((filter) => filter.label === 'ClasseurId')?.value;
        const rightClassification = this.classements.find((item) => item.id === classificationCode);
        const rightBinder = rightClassification.classeurs.find((binder) => binder.id === binderCode);
        const rightFolder = rightBinder.chemises.find((folder) => folder.id === x.value);
        this.translatedFilters.push({
          labelToTranslate: 'Chemise',
          isLabel: ' is ',
          endLabelItalic: rightFolder.description,
        });
      } else if (x.label === 'StIds') {
        //Statut
        const statusArray = [];
        let statusLabels = '';
        x.value.map((x) => {
          statusArray.push(this.statutGlobalLV.find((statut) => statut.value === x)?.label);
        });
        statusLabels = statusArray.join(', ');
        if (statusArray?.length === 1) {
          this.translatedFilters.push({
            labelToTranslate: 'Statut',
            isLabel: ' is ',
            endLabelItalic: statusLabels,
          });
        } else {
          this.translatedFilters.push({
            labelToTranslate: 'Statuts',
            isLabel: ' are ',
            endLabelItalic: statusLabels,
          });
        }
      } else if (x.label === 'MultipleStIds') {
        // Etiquettes
        const tagsArray = [];
        let tagsLabels = '';
        x.value.map((x) => {
          tagsArray.push(this.tagsLV.find((tag) => tag.value === x)?.label);
        });
        tagsLabels = tagsArray.join(', ');
        if (tagsArray.length === 1) {
          this.translatedFilters.push({
            labelToTranslate: 'Etiquette',
            isLabel: ' is ',
            endLabelItalic: tagsLabels,
          });
        } else {
          this.translatedFilters.push({
            labelToTranslate: 'Etiquettes',
            isLabel: ' are ',
            endLabelItalic: tagsLabels,
          });
        }
      } else if (x.label === 'NatureIds') {
        // Natures
        const naturesArray = [];
        let naturesLabels = '';
        x.value.map((x) => {
          naturesArray.push(this.naturesLV.find((nature) => nature.value === x)?.label);
        });
        naturesLabels = naturesArray.join(', ');
        if (naturesArray.length === 1) {
          this.translatedFilters.push({
            labelToTranslate: 'Nature',
            isLabel: ' is ',
            endLabelItalic: naturesLabels,
          });
        } else {
          this.translatedFilters.push({
            labelToTranslate: 'Natures',
            isLabel: ' are ',
            endLabelItalic: naturesLabels,
          });
        }
      } else if (x.label === 'SourceIds') {
        //Sources
        const sourcesArray = [];
        let sourcesLabels = '';
        x.value.map((x) => {
          sourcesArray.push(this.sourcesLV.find((source) => source.value === x)?.label);
        });
        sourcesLabels = sourcesArray.join(', ');
        if (sourcesArray.length === 1) {
          this.translatedFilters.push({
            labelToTranslate: 'Source',
            isLabel: ' is ',
            endLabelItalic: sourcesLabels,
          });
        } else {
          this.translatedFilters.push({
            labelToTranslate: 'Sources',
            isLabel: ' are ',
            endLabelItalic: sourcesLabels,
          });
        }
      } else if (
        x.label === 'DtEntreeMin' ||
        x.label === 'DtEntreeMax' ||
        x.label === 'DtEcheanceMin' ||
        x.label === 'DtEcheanceMax' ||
        x.label === 'DtPostaleMin' ||
        x.label === 'DtPostaleMax' ||
        x.label === 'DtDocumentMin' ||
        x.label === 'DtDocumentMax' ||
        x.label === 'DtEncodageMin' ||
        x.label === 'DtEncodageMax' ||
        x.label === 'DtCreationMin' ||
        x.label === 'DtCreationMax'
      ) {
        // Dates
        this.translatedFilters.push({
          labelToTranslate: x.label,
          isLabel: ' is ',
          endLabelItalic: moment(x.value, 'YYYY-MM-DD').format('DD/MM/YYYY'),
        });
      } else if (x.label === 'NatureCustomFieldsSearch' && x.value.length > 0) {
        //Champs complémentaires sur la nature
        x.value.map((field) => {
          if (field.dateValue) {
            this.translatedFilters.push({
              labelToTranslate: field.label,
              isLabel: ' is ',
              endLabelItalic: moment(field.dateValue, 'YYYY-MM-DD').format('DD/MM/YYYY'),
            });
          } else if (field.decimalValue || field.numberValue || field.textValue) {
            if (field.type === 'checkbox') {
              this.translatedFilters.push({
                labelToTranslate: field.label,
                isLabel: ' is ',
                endLabelItalic: field.numberValue ? '✔️' : '❌',
              });
            } else {
              this.translatedFilters.push({
                labelToTranslate: field.label,
                isLabel: ' is ',
                endLabelItalic: field.decimalValue || field.numberValue || field.textValue,
              });
            }
          } else if (field.type === 'dropdown') {
            const foundNature = this.naturesLV.find((nature) => nature.value === field.natureId);
            if (foundNature) {
              const fieldIds = [field.id, field.natureCustomFieldId];
              const foundCustomData = foundNature.natureCustomFields.find(
                (natureCustomField) => fieldIds.includes(natureCustomField.id) && fieldIds.includes(natureCustomField.customFieldId)
              );
              if (foundCustomData) {
                const listOfNames = [];
                field.listValueItemId.forEach((dropdownId) => {
                  const foundLabel = foundCustomData.listItems.find((item) => item.id === dropdownId)?.name;
                  if (foundLabel) {
                    listOfNames.push(foundLabel);
                  }
                });
                field.listValueItemLabel = listOfNames.join(', ');
              }
            }
            this.translatedFilters.push({
              labelToTranslate: field.label,
              isLabel: ' is ',
              endLabelItalic: field.listValueItemLabel,
            });
          }
        });
      } else if (
        x.label === 'Objet' ||
        x.label === 'BoiteArchive' ||
        x.label === 'Id' ||
        x.label === 'ExpediteurLibre' ||
        x.label === 'DestinataireLibre' ||
        x.label === 'ReferenceRecommande' ||
        x.label === 'Remarques'
      ) {
        // Aucun changement requis
        this.translatedFilters.push({ labelToTranslate: x.label, isLabel: ' is ', endLabelItalic: x.value });
      }
    });
  }

  private getServices() {
    return new Promise((resolve) => {
      this.servicesService.fetchMappedServicesToPrimeNGDropdowns().subscribe({
        next: (response) => {
          this.services = response;
          resolve(true);
        },
        error: (error) => {
          console.error('Error : ', error);
        },
      });
    });
  }

  private getClassements(): Promise<boolean> {
    return new Promise((resolve) => {
      const indexOfClassement = this.filtersReceived.map((x) => x.label).indexOf('ClassementIds');
      if (indexOfClassement > -1) {
        this.classificationsService.fetchFoldersClassificationV2().subscribe({
          next: (response: BinderClassificationDtoV2[]) => {
            this.classements = response;
            resolve(true);
          },
          error: (error: HttpErrorResponse) => {
            console.error('Error : ', error);
          },
        });
      } else {
        this.classements = [];
        resolve(true);
      }
    });
  }

  getStatus(): Promise<boolean> {
    return new Promise((resolve) => {
      this.statutGlobalLV = [];
      this.documentsService.fetchDocumentsStatutes().subscribe({
        next: (res: DocumentStatusDto[]) => {
          if (res.length > 0) {
            res.map((item) => {
              this.statutGlobalLV.push({
                label: item.description,
                value: item.id,
                color: item.color && item.color !== 'Pas de couleur' ? item.color : '#ffffff',
              });
            });
          }
          resolve(true);
        },
      });
    });
  }

  getTags(): Promise<boolean> {
    return new Promise((resolve) => {
      this.multipleStatutesService.getMultipleStatus().subscribe({
        next: (res: MultipleStatutesDTO[]) => {
          this.tagsLV = [];
          if (res?.length > 0) {
            res.map((item) => {
              if (item.notUsed === false && item.description) {
                this.tagsLV.push({ label: item.description, value: item.id });
              }
            });
          }
          resolve(true);
        },
      });
    });
  }

  setOverlayPanel(event): void {
    const target = document.getElementById('overlayId');
    if (target) {
      this.overlayButtonDisplayFilters.toggle(event, target);
    }
  }

  reset(event): void {
    event.preventDefault();
    event.stopPropagation();
    this.resetAdvancedSearch.emit('reset');
  }
}
